import React, { useState } from "react";
import "./HomeComp1.css";
import CountUp from "react-countup";
const HomeComp1 = () => {
    const [activeTab, setActiveTab] = useState("Coffee");
   
  return (
    <>
    <section className="ftco-intro">
      <div className="container-wrap">
        <div className="wrap d-md-flex align-items-xl-end">
          <div className="info">
            <div className="row no-gutters" data-aos="fade-up">
              <div className="col-md-4 d-flex ">
                <div className="icon">
                  <span className="icon-phone"></span>
                </div>
                <div className="text ">
                  <h3 className="text-light">+91 7510266377</h3>
                  <p className="p-color"></p>
                </div>
              </div>
              <div className="col-md-4 d-flex text-left">
                <div className="icon">
                  <span className="icon-my_location"></span>
                </div>
                <div className="text text-light">
                  <h3>AUWM Compound Vengeri</h3>
                  <p className="p-color">Building No: 9/2467 (H4), Calicut / Kakkodi road, Calicut dist. </p>
                </div>
              </div>
              <div className="col-md-4 d-flex text-left">
                <div className="icon">
                  <span className="icon-clock-o"></span>
                </div>
                <div className="text text-light">
                  <h3>Open 24 x 7</h3>
                  <p className="p-color"></p>
                </div>
              </div>
            </div>
          </div>
         {/* <div className="book p-4">
  <h3>Book a Table</h3>
  <form action="#" className="appointment-form">
    <div className="d-md-flex">
      <div className="form-group">
        <input type="text" className="form-control" placeholder="First Name" />
      </div>
      <div className="form-group ml-md-4">
        <input type="text" className="form-control" placeholder="Last Name" />
      </div>
    </div>
    <div className="d-md-flex">
      <div className="form-group">
        <div className="input-wrap">
          <div className="icon"><span className="ion-md-calendar" /></div>
          <input type="text" className="form-control appointment_date" placeholder="Date" />
        </div>
      </div>
      <div className="form-group ml-md-4">
        <div className="input-wrap">
          <div className="icon"><span className="ion-ios-clock" /></div>
          <input type="text" className="form-control appointment_time" placeholder="Time" />
        </div>
      </div>
      <div className="form-group ml-md-4">
        <input type="text" className="form-control" placeholder="Phone" />
      </div>
    </div>
    <div className="d-md-flex">
      <div className="form-group">
        <textarea name id cols={30} rows={2} className="form-control" placeholder="Message" defaultValue={""} />
      </div>
      <div className="form-group ml-md-4">
        <input type="submit" defaultValue="Appointment" className="btn btn-white py-3 px-4 rounded-0" />
      </div>
    </div>
  </form>
</div> */}

        </div>
      </div>
    </section>

    <section className="ftco-about d-md-flex bg-imagea">
      <div
        className="one-half img"
        style={{ backgroundImage: "url(images/coffeeBg9.jpg)" }}
      ></div>
      <div className="one-half" data-aos="fade-up">
        <div className="overlap">
          <div className="heading-section" >
            <span className="subheading">Discover</span>
            <h2 className="mb-4 z-1 text-light">Our Story</h2>
          </div>
          <div>
            <p className="p-color">
            
              Making good coffee takes time, patience and love.
                 Sera coffee helps us with that.  We are remembered by many from time to time for the same dedication we put into our work. 
               Similarly, everyone remembers sera coffee for its quality. 
               We harvest beans from coffee plants that are over 25 years old, 
               consistently research the same plantations and implement the best coffee brewing methods,
                and we take care of our quality and hygiene process. 
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="ftco-section ftco-services">
      <div className="container">
        <div className="row" data-aos="fade-up">
          <ServiceItem
            iconClass="flaticon-choices"
            title="Easy to Order"
            description="We ship our coffee all over India and we are happy to have thousands of happy customers who love our coffee to the Middle East and Europe as well. "/>
          <ServiceItem
            iconClass="flaticon-delivery-truck"
            title="Fastest Delivery"
            description="Speed meets reliability in our fastest delivery service. Get your order in record time!"
          />
          <ServiceItem
            iconClass="flaticon-coffee-bean"
            title="Quality Coffee"
            description=" We take great care of our coffee to ensure the best quality in every sip, to ensure your cup is just right for your taste!"
          />
        </div>
      </div>
    </section>
    </>
  );
};

const ServiceItem = ({ iconClass, title, description }) => {
  return (
    <div className="col-md-4 ">
      <div className="media d-block text-center block-6 services">
        <div className="icon d-flex justify-content-center align-items-center mb-5">
          <span className={iconClass}></span>
        </div>
        <div className="media-body">
          <h3 className="heading">{title}</h3>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default HomeComp1;
